// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2N59l","description":"PatientConsentPreview_description__E_nKq"};